import { render, staticRenderFns } from "./Searchbar.vue?vue&type=template&id=308b84c6&scoped=true&"
import script from "./Searchbar.vue?vue&type=script&lang=ts&"
export * from "./Searchbar.vue?vue&type=script&lang=ts&"
import style0 from "./Searchbar.vue?vue&type=style&index=0&id=308b84c6&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "308b84c6",
  null
  
)

export default component.exports